export const name = 'remoteStructureRenderer' as const

export const BuilderWidgetsPlatformModelSymbol = Symbol('BuilderWidgetsPlatformModel')
